import React from 'react';
import { Box, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import { PsBeaconLoadingSpinner } from '../components/shared/BeaconRegister';

export default function Loading({ headerText = 'Preparing your planning experience...' }) {
    return (
        <Box sx={{ height: 600 }}>
            <Box
                sx={{
                    height: '100%',
                    width: '100%',
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}>
                <Typography
                    type="headline" loose scale={100}
                    sx={{ paddingBottom: '24px' }}>
                    {headerText}
                </Typography>
                <PsBeaconLoadingSpinner aria-label="loading-spinner" scale="maxi" />
            </Box>
        </Box>
    );
}
